<div class="flex flex-col justify-center items-center">
  <h2 class="title-text">QR Code Generation</h2>

  <div
    id="print-section"
    class="qr-label-cont"
    style="overflow-y: auto; max-height: 80vh"
  >
    <ng-container *ngFor="let formInfo of form10aInfo">
      <div class="qr-code-container qr-label page-break flex flex-col justify-center items-center text-center">
        <div class="print-center-text text-lg tracking-tight font-bold z-99">{{ formInfo.form10a?.formCustomer?.name }}</div>
        <qrcode
          class="print-center-text print-scale-up print-pt-qr"
          [qrdata]="formInfo.qrJson"
          [width]="256"
          [errorCorrectionLevel]="'M'"
          [elementType]="'svg'"
        ></qrcode>
        <h3 class="print-center-text text-3xl font-bold print-pt-id z-99">{{ formInfo.form10a?.bookingRef }}</h3>
        <h3 class="print-center-text text-md">Booked in: {{ formInfo.form10a?.dateReceived | date: "dd/MM/yyyy" }}</h3>
        <h3 class="print-center-text text-md">Serial Number: {{ formInfo.form10a?.formSerialNumber?.name }}</h3>
        <h3 class="print-center-text text-md">Qty in Consignment: {{ formInfo.form10a?.itemsInConsignment }}</h3>
      </div>
    </ng-container>
  </div>

  <div class="flex flex-row mt-8">
    <button mat-flat-button class="back-button mr-8" (click)="close()">
      Cancel
    </button>
    <span fxFlex="8px"></span>
    <button
      mat-flat-button
      color="primary"
      class="forward-button ml-8"
      printSectionId="print-section"
      ngxPrint
      [useExistingCss]="true"
      (click)="print()"
    >
      Print
    </button>
  </div>
</div>
